<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Work Orders</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white hover-white" @click="openCreateModal('createModal')">
         <i class="fa fa-plus fs-11 hover-white"></i>  Create New Work Order
        </button>
       
      </div>
    </div>
   
    <!-- Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
   
    <div class="card p-1 bg-white">
      <!-- Modal with Createrequest inside slot -->
      <FormModal ref="createModal" title="Create New Work Order" id="create_work_order_form_modal">
        <CreateWorkOrder  ref="CreateWorkOrderForm" @created="onCreated" @close="closeCreateModal('createModal')" />
      </FormModal>

      <FormModal ref="editModal" title="Edit Work Order" id="edit_work_order_form_modal">
        <EditWorkOrder
          v-if="editingWorkOrderId"
          :workOrderId="editingWorkOrderId"
          @updated="onUpdated"
          @close="closeEditModal"
        />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Work Orders..." />

      <!-- Work Orders Table -->
      <div v-else class="table-wrapper ">
        <ListTable>
          <thead>
            <tr>
              <th @click="sortBy('name')" class="sortable">
                 Work Order <i :class="getSortIcon('name')"></i>
              </th>
             
              <th @click="sortBy('categories')" class="sortable">
                Categories <i :class="getSortIcon('categories')"></i>
              </th>

               <th @click="sortBy('location')" class="sortable">
                Location <i :class="getSortIcon('location')"></i>
              </th>
              <th @click="sortBy('work_type')" class="sortable">
                Type <i :class="getSortIcon('work_type')"></i>
              </th>
              <th @click="sortBy('frequency')" class="sortable">
                Frequency <i :class="getSortIcon('frequency')"></i>
              </th>
              <th @click="sortBy('last_schedule')" class="sortable">
                Last Schedule <i :class="getSortIcon('last_schedule')"></i>
              </th>
               
              
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
             <tr v-for="wo in sortedData" :key="wo.external_id">
              <td>
              <button  @click.prevent="$router.push(`/wo/schedule/list/${wo.external_id}`)" class="text-dark fw-semibold  btn btn-sm p-0" title="Click to view details">
            {{ wo.name }}
              </button>
              <div class="mt-0">
                <small class="text-muted">#{{ wo.external_id }}</small>
              </div>
              </td>
              <td>
                <span v-for="(categ, index) in wo.get_categories" :key="categ.id">
                  {{ categ.name }}<span v-if="index < wo.get_categories.length - 1">, </span>
                </span>
                <span v-if="!wo.get_categories || wo.get_categories.length === 0">N/A</span>
            </td>
              <td>{{ wo.get_location?.name || "N/A" }}</td>
                <td><span class="type-badge" :class="'type-' + wo.work_type">{{ wo.work_type || 'N/A' }}</span></td>
                <td>{{ wo.frequency || 'N/A' }}</td>
              <td>{{ wo.last_schedule || '---' }}</td>        
              <td>
                <TableActionDropdown>
                  <li><button class="dropdown-item" @click.prevent="goToProfile(wo.external_id)"><i class="fa fa-eye text-info "></i>View Details</button></li>
                  <li><button class="dropdown-item" @click.prevent="goToTemplate(wo.get_template)"><i class="fa fa-file-alt text-primary "></i>Manage Template</button></li>
                  <li><button class="dropdown-item" @click.prevent="editWorkOrder(wo.external_id)"><i class="fa fa-pencil text-primary "></i>Edit</button></li>
                  <li><button class="dropdown-item text-danger" @click.prevent="deleteWorkOrder(wo.external_id)"><i class="fa fa-trash text-danger "></i>Delete</button></li>
                </TableActionDropdown>
              </td>
            </tr>
            <tr v-if="work_orders.length === 0">
              <td colspan="7" class="text-center">No work orders found</td>
            </tr>

          </tbody>
        </ListTable>
        
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateWorkOrder from '@/views/WO/CreateWorkOrder.vue'
import EditWorkOrder from '@/views/WO/EditWorkOrder.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'

export default {
  name: 'WorkOrderList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateWorkOrder,
    EditWorkOrder,
    ListTable,
    TableActionDropdown
  },
  data() {
    return {
      work_orders: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      showEditModal: false,
      editingWorkOrderId: null,
      filterManager: null,
      sortColumn: 'name',
      sortOrder: 'asc',
      currentFilters: {},
      categories: [],
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.work_orders];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          // Handle nested properties
          if (this.sortColumn === 'categories') {
            valA = (a.get_categories || []).map(c => c.name).join(', ');
            valB = (b.get_categories || []).map(c => c.name).join(', ');
          }
          if (this.sortColumn === 'location') {
            valA = a.get_location?.name || '';
            valB = b.get_location?.name || '';
          }
          if (this.sortColumn === 'last_schedule') {
            valA = a.last_schedule || '';
            valB = b.last_schedule || '';
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() {
    // Step 1: Fetch list first
    this.fetchListAndInitialize()
  },
  methods: {
    goToProfile(id) {
      this.$router.push(`/wo/profile/${id}`)
    },
    goToTemplate(temp) {
      if (temp) {
        this.$router.push(`/template/builder/${temp.external_id}`)
      }
    },
    openCreateModal(ref) {
      this.$refs[ref].showModal()
    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    editWorkOrder(id) {
      this.editingWorkOrderId = id
      this.$nextTick(() => {
        if (this.$refs.editModal) {
          this.$refs.editModal.showModal()
        }
      })
    },

    async onUpdated() {
      this.closeEditModal()
      await this.fetchList()
    },

    closeEditModal() {
      if (this.$refs.editModal) {
        this.$refs.editModal.closeModal()
      }
      this.editingWorkOrderId = null
    },

    async fetchListAndInitialize() {
      // First fetch the work orders list
      await this.fetchList()
      
      // Then fetch categories
      await this.fetchCategories()
      
      // Finally initialize filters
      this.$nextTick(() => {
        setTimeout(() => {
          this.initFilters();
        }, 100);
      });
    },

    async fetchCategories() {
      const result = await form_api_submit({
        url: 'wo/category/dropdown',
        method: 'GET',
        show_success_toast: false,
        show_error_toast: true,
      });
      if (result.success) {
        this.categories = result.data || [];
      }
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      // Prepare category options for Category filter
      const categoryOptions = (this.categories || []).map(category => ({
        value: String(category.id),
        label: category.name
      }));

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "category",
            label: "Category",
            type: "checkbox",
            options: categoryOptions
          },
          {
            key: "work_type",
            label: "Type",
            type: "checkbox",
            options: [
              { value: "preventive", label: "Preventive" },
              { value: "corrective", label: "Corrective" },
              { value: "reactive", label: "Reactive" }
            ]
          },
          {
            key: "frequency",
            label: "Frequency",
            type: "checkbox",
            options: [
              { value: "custom", label: "Custom" },
              { value: "daily", label: "Daily" },
              { value: "weekly", label: "Weekly" },
              { value: "monthly", label: "Monthly" },
              { value: "yearly", label: "Yearly" }
            ]
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchList();
    },

    async fetchList() {
      this.loading = true

      const payload = {
        page: this.pagination.current_page,
        ...this.currentFilters
      }

      const result = await form_api_submit({
        url: 'wo/list',
        method: 'GET',
        data: payload,
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.work_orders = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchList()
    },

    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}

/* Filters Wrapper */
.filters-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 8px 0;
}



.filters-wrapper .btn {
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 12px;
}

/* Type Badges */
.type-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
}

.type-preventive {
  background: #dbeafe;
  color: #1e40af;
}

.type-corrective {
  background: #fef3c7;
  color: #92400e;
}

.type-reactive {
  background: #fee2e2;
  color: #991b1b;
}

.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable:hover {
  background-color: #f8f9fa;
}

/* Table styling */
.table-wrapper {
  overflow-x: auto;
}

:deep(table) {
  width: 100%;
  border-collapse: collapse;
}

:deep(th) {
  background-color: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  border-bottom: 1px solid #dee2e6;
}

:deep(td) {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

:deep(tr:hover) {
  background-color: #f8f9fa;
}

/* Responsive */
@media (max-width: 768px) {
  :deep(th),
  :deep(td) {
    padding: 8px 12px;
  }
  
  .filters-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filters-wrapper .btn {
    align-self: flex-end;
  }
}
</style>